import { Chip, Stack } from '@mui/material';
import React from 'react';
import ShowContainer from '../../components/material-ui/ShowContainer';
import { IconLock } from '@tabler/icons-react';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view';
import styled from '@emotion/styled';

export default function CusThreeItem({
  groupId,
  parentId,
  setClickedGroupId,
  setChooseGroupeId,
  viewId,
  isLocked,
  groupName,
  gamerCount,
  isHighlight,
  children
}) {
  const CustomTreeItem = styled(TreeItem)({
    [`& .${treeItemClasses.iconContainer}`]: { '& .close': { opacity: 0.3 } }
  });

  const itemId = parentId ? `${parentId}-${groupId}` : String(groupId);

  return (
    <CustomTreeItem
      title={`id: ${groupId}`}
      itemId={itemId}
      label={
        <Stack
          direction={'row'}
          alignItems={'center'}
          color={isHighlight ? 'error.main' : ''}
          gap={0.5}
          onClick={() => setClickedGroupId?.(groupId)}>
          <ShowContainer condition={isLocked}>
            <IconLock color="red" size={16} />{' '}
          </ShowContainer>
          {groupName} <ShowContainer condition={viewId}>({groupId})</ShowContainer>
          <ShowContainer condition={gamerCount}>
            <Chip
              label={
                <span>
                  <span>{gamerCount?.online}</span> /{gamerCount?.total}
                </span>
              }
              color="secondary"
              size="small"
            />
          </ShowContainer>
        </Stack>
      }
      onClick={() => setChooseGroupeId(groupId)}>
      {children}
    </CustomTreeItem>
  );
}
